import { render, staticRenderFns } from "./period-button.vue?vue&type=template&id=139d4098&scoped=true"
import script from "./period-button.vue?vue&type=script&lang=js"
export * from "./period-button.vue?vue&type=script&lang=js"
import style0 from "./period-button.vue?vue&type=style&index=0&id=139d4098&prod&lang=scss&scoped=true"
import style1 from "./period-button.vue?vue&type=style&index=1&id=139d4098&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139d4098",
  null
  
)

export default component.exports